export const contractOptions = [
  { value: 0, label: "Vorvertrag" },
  { value: 1, label: "Freihopfen" },
  { value: 3, label: "Poolhopfen" },
];
